// « Une question ? » (refonte 2026), porté de src/sections/pdp.js du prototype : au survol (souris) la
// réponse apparaît, au tap ou à Entrée elle bascule. La couche réponse se découvre case par case depuis
// le centre (clip-path fait de carrés), au même rythme que la mosaïque des photos.
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const TILE = 50, REVEAL_MS = 450;

function tileReveal(el) {
  let p = 0, target = 0, from = 0, t0 = 0, raf = 0, tiles = [];
  const layout = () => {
    const w = el.offsetWidth, h = el.offsetHeight;
    const cols = Math.ceil(w / TILE), rows = Math.ceil(h / TILE);
    const cx = cols / 2, cy = rows / 2, max = Math.hypot(cx, cy);
    tiles = [];
    for (let y = 0; y < rows; y++) for (let x = 0; x < cols; x++)
      tiles.push({ x: x * TILE, y: y * TILE, k: Math.hypot(x + .5 - cx, y + .5 - cy) / max * .999 });
    tiles.sort((a, b) => a.k - b.k);
  };
  const draw = () => {
    if (p <= 0) { el.style.clipPath = ''; return; }
    if (p >= 1) { el.style.clipPath = 'none'; return; }
    let d = '';
    for (const t of tiles) { if (t.k >= p) break; d += `M${t.x} ${t.y}h${TILE + 1}v${TILE + 1}h-${TILE + 1}z`; }
    el.style.clipPath = d ? `path('${d}')` : '';
  };
  const ease = u => u < .5 ? 4 * u * u * u : 1 - Math.pow(-2 * u + 2, 3) / 2;
  const tick = now => {
    const u = Math.min(1, (now - t0) / (REVEAL_MS * Math.abs(target - from) || 1));
    p = from + (target - from) * ease(u);
    draw();
    raf = u < 1 ? requestAnimationFrame(tick) : 0;
  };
  new ResizeObserver(() => { layout(); draw(); }).observe(el);
  layout();
  return v => {
    if (v === target) return;
    if (reduced || document.hidden) { p = target = v; draw(); return; }
    from = p; target = v; t0 = performance.now();
    cancelAnimationFrame(raf); raf = requestAnimationFrame(tick);
  };
}

function initFaq(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  root.querySelectorAll('.faq__card').forEach(card => {
    const btn = card.querySelector('.faq__q button');
    const reveal = tileReveal(card.querySelector('.faq__a'));
    const set = on => { card.classList.toggle('is-revealed', on); btn.setAttribute('aria-expanded', String(on)); reveal(on ? 1 : 0); };
    card.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse' && fine.matches) set(true); });
    card.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse' && fine.matches) set(false); });
    btn.addEventListener('click', () => set(!card.classList.contains('is-revealed')));
    // un tap sur la réponse la replie (les liens dedans restent cliquables)
    card.querySelector('.faq__a').addEventListener('click', e => { if (!fine.matches && !e.target.closest('a')) set(false); });
  });
}

document.querySelectorAll('[data-faq]').forEach(initFaq);
document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-faq]').forEach(initFaq));
